// extracted by mini-css-extract-plugin
export default {"toggle":"ServiceModifiers_toggle__hmGex","list":"ServiceModifiers_list__DbHmh","question":"ServiceModifiers_question__oBYhv","answer":"ServiceModifiers_answer__hZnzD"};